/**
 * Staff Dashboard wrapper — switches between v2 (feature-flagged) and legacy.
 *
 * The default export is what App.js already routes to for /staff/dashboard.
 * When staff_portal_v2_enabled + staff_dashboard_v2_enabled evaluate true,
 * we render StaffDashboardV2 inside the StaffPortalShell. Otherwise the
 * legacy StaffDashboard.js renders exactly as before.
 *
 * This is the ONLY place App.js needs to touch to enable the v2 rollout
 * for the dashboard route.
 */
import React from 'react';
import LegacyStaffDashboard from '@/pages/staff/StaffDashboard';
import StaffDashboardV2 from '@/pages/staff/StaffDashboardV2';
import StaffPortalShell from '@/components/staff-v2/StaffPortalShell';
import { useStaffV2Flags } from '@/lib/staffV2Flags';

export default function StaffDashboardRoute() {
  const flags = useStaffV2Flags();
  // While flags load, avoid flashing the legacy layout — show a minimal
  // placeholder. The flag map resolves fast (single request, cached).
  if (flags.loading) {
    return <div className="min-h-[40vh] flex items-center justify-center text-sm text-muted-foreground" aria-busy="true">Loading…</div>;
  }
  if (flags.staff_portal_v2_enabled && flags.staff_dashboard_v2_enabled) {
    return (
      <StaffPortalShell title="Dashboard" subtitle="Your operational home">
        <StaffDashboardV2 />
      </StaffPortalShell>
    );
  }
  return <LegacyStaffDashboard />;
}
